import React from 'react';
import { VerticalSpacer } from './core/core';
import { myBrowserHistory } from './ApplicationState';
import PrimaryButton from './components/PrimaryButton/PrimaryButton';
import { Dialog, DialogContent } from './components/Dialog';
import styles from './SCSS/Login.module.scss';

const redirectToSignUp = () => myBrowserHistory.push(`/signup?signUpFromOauthLogin=true`);

const NonexistentAccountDialog = ({ isShow, onHide }) => {
  return (
    <Dialog
      open={isShow}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onHide();
        }
      }}
    >
      <DialogContent
        className='w-[min(92vw,56rem)] rounded-[1rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_20px_50px_rgba(15,23,42,0.28)]'
        overlayClassName='bg-black/50'
      >
        <div className='relative border-b border-slate-200 px-[2rem] pb-[1.4rem] pt-[1.6rem]'>
          <button
            type='button'
            aria-label='Close'
            onClick={onHide}
            className='absolute right-[1.2rem] top-[1.2rem] flex h-[2.6rem] w-[2.6rem] items-center justify-center rounded-full border-0 bg-transparent p-0 text-[2.2rem] leading-none text-slate-600 outline-none transition-colors hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus-visible:ring-1 focus-visible:ring-slate-300'
          >
            ×
          </button>
          <h3 className='m-0 text-[2.2rem] leading-[1.2] text-slate-800'>Account Sign Up Required</h3>
        </div>
        <div className='px-[2rem] pb-[2rem] pt-[1.6rem]'>
          <div>
            <p className={`${styles.NormalText} ${styles.forgotPasswordText}`}>
              We're sorry, it appears you haven't signed up for an account on Peekapak yet. Would you like to sign up
              for a free account right now?
            </p>
            <VerticalSpacer ems={2} />
            <div className={styles.forgotPasswordButton}>
              <PrimaryButton small onClick={onHide}>
                No
              </PrimaryButton>
            </div>
            <div className={styles.forgotPasswordButton}>
              <PrimaryButton small onClick={redirectToSignUp}>
                Yes
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NonexistentAccountDialog;
